<template>
  <div class="colofon-wrapper">
    <div class="colofon-scroll-wrapper">
      <div class="colofon-content-wrapper">
        <div v-html="colofon">
        </div>
      </div>
    </div>
    <button type="button" name="button" @click="close()">Close</button>

  </div>
</template>

<script>
export default {
  name: 'Colophon',
  props: [
    'colofon',
  ],
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">

.colofon-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  width: calc(50% + 1px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 50;
  background: #000;
  color: white;
  transform: translateX(0%);
  transition: transform 0.5s;


  &.v-enter {
    transform: translateX(100%);
  }
  &.v-enter-to {
    transform: translateX(0%);
  }
  &.v-leave {
    transform: translateX(0%);
  }
  &.v-leave-to {
    transform: translateX(100%);
  }

  .colofon-content-wrapper {
    padding: 0 20px;
    min-height: 100vh;
    z-index: 2;

    .colofon-search-text {
      overflow: hidden;
      height: 0;
    }
  }

  button {
    position: fixed;
    top: 0px;
    right: 0px;
    padding: 21px;
    height: auto;
    width: auto;
    border-radius: 100%;
    color: white;
    cursor: pointer;
    &:hover {
      background: black;
      color: white;

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Colofon.vue